export const OnexAppRoutes = {
  singIn: () => '/sign-in',
  fallback: () => '*',
  home: () => '/',
  signUp: () => '/sign-up',
  customers: () => '/customers',
  orders: () => '/orders',
  customerSingle: () => '/customer/:id',
  balance: () => '/balance',
  onex_coins: () => '/onex-coins',
  debts: () => '/users-debt',
  onlinePayment: () => '/online-payment',
  scan: () => '/scan',
  scanSingle: () => '/scan/:id',
  consignment: () => '/consignment',
  consignmentLocation: () => '/consignment/location',
  expected: () => '/expected',
  ordersCheck: () => '/orders-check',
  ordersFailed: () => '/orders-failed',
  delivery: () => '/delivery',
  inLocalCountry: () => 'in-local-country',
  downloadExcel: () => '/download-excel',
  receiveOrders: () => '/receive-orders',
  dashboard: () => '/dashboard',
  membersAndRoles: () => '/members',
  slides: () => '/slides',
  blog: () => '/blog',
  banners: () => '/banners',
  shops: () => '/shops',
  reports: () => '/reports',
  reportCost: () => '/report-cost',
  notifications: () => '/notifications',
  stories: () => '/stories',
  roles: () => '/roles',
  actionsHistory: () => '/actions-history',
  prime_users: () => '/prime-users',
  test_users: () => '/test-users',
  tariffs: () => '/tariffs',
  customized_pricing: () => '/customized-pricing',
  app_versions: () => '/app-versions',
  lost_orders: () => '/lost-orders',
  alert_users: () => '/alert-users',
  levels: () => '/levels',
  benefits: () => '/benefits',
  wow_coin: () => '/wow-coin',
  popup_notifications: () => '/popup-notifications',
  goals: () => '/goals',
  avatars: () => '/avatars',
};
